import Vue from 'vue'
import {
    Slider,
    ColorPicker
} from 'element-ui'
import '../element-variables.scss'

Vue.use(Slider)
Vue.use(ColorPicker)